import React, { useEffect, Suspense, lazy } from 'react';
import { Hero, TestimonialsHero } from './components/Hero';
import { PurchasePopup } from './components/Shared';
import { initPixel } from './utils/pixel';
// Below-the-fold sections are lazy-loaded to speed up initial render.
// lazy requires a default export, so we adapt the named exports here.
const PainSection = lazy(() => import('./components/Product').then(m => ({
  default: m.PainSection
})));
const ProductOverview = lazy(() => import('./components/Product').then(m => ({
  default: m.ProductOverview
})));
const TomosSection = lazy(() => import('./components/Product').then(m => ({
  default: m.TomosSection
})));
const WhatIncluded = lazy(() => import('./components/Product').then(m => ({
  default: m.WhatIncluded
})));
const BonusSection = lazy(() => import('./components/Bonus').then(m => ({
  default: m.BonusSection
})));
const UrgencySection = lazy(() => import('./components/Pricing').then(m => ({
  default: m.UrgencySection
})));
const PricingSection = lazy(() => import('./components/Pricing').then(m => ({
  default: m.PricingSection
})));
const PackCompletoDetail = lazy(() => import('./components/Pricing').then(m => ({
  default: m.PackCompletoDetail
})));
const GuaranteeSection = lazy(() => import('./components/Pricing').then(m => ({
  default: m.GuaranteeSection
})));
const ExtendedTestimonials = lazy(() => import('./components/Pricing').then(m => ({
  default: m.ExtendedTestimonials
})));
const FAQSection = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQSection
})));
const Footer = lazy(() => import('./components/FAQ').then(m => ({
  default: m.Footer
})));
const SectionFallback = () => <div className="py-20 bg-slate-50" aria-hidden="true" data-id="element-0" />;
export function App() {
  useEffect(() => {
    initPixel();
  }, []);
  return <div className="min-h-screen bg-slate-50 font-sans selection:bg-amber-200 selection:text-amber-900" data-id="element-1">
      {/* Above-the-fold: load immediately */}
      <Hero data-id="element-2" />
      <TestimonialsHero data-id="element-3" />

      {/* Below-the-fold: lazy-loaded with a single Suspense boundary */}
      <Suspense fallback={<SectionFallback data-id="element-5" />} data-id="element-4">
        <PainSection data-id="element-6" />
        <ProductOverview data-id="element-7" />
        <TomosSection data-id="element-8" />
        <WhatIncluded data-id="element-9" />
        <BonusSection data-id="element-10" />
        <UrgencySection data-id="element-11" />
        <PricingSection data-id="element-12" />
        <PackCompletoDetail data-id="element-13" />
        <ExtendedTestimonials data-id="element-14" />
        <GuaranteeSection data-id="element-15" />
        <FAQSection data-id="element-16" />
        <Footer data-id="element-17" />
      </Suspense>

      <PurchasePopup data-id="element-18" />
    </div>;
}